// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateAgentMarketingProfileProfilePhoto(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "AgentMarketingProfileProfilePhotoUpdated",
    "ProfileSettingsChangedError"
  ]);
}

let variablesConverter = {"profilePhotoWithOriginalInput":{"originalPhoto":{"r":"profilePhotoInput"},"croppedPhoto":{"r":"profilePhotoInput"}},"updateAgentMarketingProfileProfilePhotoInput":{"profilePhoto":{"r":"profilePhotoWithOriginalInput"}},"profilePhotoInput":{},"__root":{"input":{"r":"updateAgentMarketingProfileProfilePhotoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateAgentMarketingProfileProfilePhoto_AgentMarketingProfileProfilePhotoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileProfilePhoto":{"u":"response_updateAgentMarketingProfileProfilePhoto"}}};

let wrapResponseConverterMap = {
  response_updateAgentMarketingProfileProfilePhoto: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateAgentMarketingProfileProfilePhoto_AgentMarketingProfileProfilePhotoUpdated_marketingProfile":{"f":""},"updateAgentMarketingProfileProfilePhoto":{"u":"response_updateAgentMarketingProfileProfilePhoto"}}};

let responseConverterMap = {
  response_updateAgentMarketingProfileProfilePhoto: unwrap_response_updateAgentMarketingProfileProfilePhoto
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function imageContentType_decode($$enum) {
  if ($$enum === "GIF" || $$enum === "WEBP" || $$enum === "JPEG" || $$enum === "PNG") {
    return $$enum;
  }
}

let imageContentType_fromString = imageContentType_decode;

let Utils = {
  imageContentType_decode: imageContentType_decode,
  imageContentType_fromString: imageContentType_fromString
};

let providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "settingsChangedMessage",
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProfileSettingsChangedError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AgentMarketingProfilePhotoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileProfilePhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AgentMarketingProfilePhotoForm_agentMarketingProfile"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileProfilePhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "AgentMarketingProfilePhotoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentMarketingProfileProfilePhoto",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentMarketingProfile",
                "kind": "LinkedField",
                "name": "marketingProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfilePhoto",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "ratio",
                            "variableName": "__relay_internal__pv__DevicePixelRatio"
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 96
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AgentMarketingProfileProfilePhotoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8338708c46d20449bff209272c4fedd7",
    "id": null,
    "metadata": {},
    "name": "AgentMarketingProfilePhotoFormMutation",
    "operationKind": "mutation",
    "text": "mutation AgentMarketingProfilePhotoFormMutation(\n  $input: UpdateAgentMarketingProfileProfilePhotoInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateAgentMarketingProfileProfilePhoto(input: $input) {\n    __typename\n    ... on ProfileSettingsChangedError {\n      settingsChangedMessage: message\n    }\n    ... on AgentMarketingProfileProfilePhotoUpdated {\n      marketingProfile {\n        ...AgentMarketingProfilePhotoForm_agentMarketingProfile\n        nodeId\n      }\n    }\n  }\n}\n\nfragment AgentMarketingProfilePhotoForm_agentMarketingProfile on AgentMarketingProfile {\n  ...AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile\n  ...AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile\n}\n\nfragment AgentMarketingProfilePhotoForm_changeProfilePhoto_agentMarketingProfile on AgentMarketingProfile {\n  profilePicture {\n    __typename\n  }\n}\n\nfragment AgentMarketingProfilePhotoForm_currentPhoto_agentMarketingProfile on AgentMarketingProfile {\n  profilePicture {\n    url(width: 96, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

let node = makeNode(providedVariablesDefinition);

let wrap_response_updateAgentMarketingProfileProfilePhoto = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentMarketingProfileProfilePhoto = unwrap_response_updateAgentMarketingProfileProfilePhoto;
exports.wrap_response_updateAgentMarketingProfileProfilePhoto = wrap_response_updateAgentMarketingProfileProfilePhoto;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
